import React, { useState, useRef } from "react";
import ".././popup.common.css";
import styles from "./Style.module.css";
import BorderedButton from "../../Buttons/BorderedButton";
import PrimaryButton from "../../Buttons/PrimaryButton";

const SkipPasswordForMembership = ({ onClose, onSubmitted, onEnterUserPassword }) => {
	const textareaRef = useRef(null);
	const [reason, setReason] = useState("");
	const [error, setError] = useState("");

	const handleTextareaInput = (e) => {
		setReason(e.target.value);
		if (error) setError("");
	};

	const handleSubmit = () => {
		const trimmed = reason.trim();
		if (!trimmed) {
			setError("Please enter a reason for override.");
			return;
		}
		if (typeof onSubmitted === "function") {
			onSubmitted({ skip: true, reason: trimmed });
		}
	};

	const handleEnterUserPassword = () => {
		if (typeof onEnterUserPassword === "function") {
			onEnterUserPassword();
		}
	};

	return (
	<div className={`${styles.skipPasswordForMembership} popup`}>
		<div className="header">
			<h2>Enter a reason for override</h2>
			<p>This helps record why the customer password was skipped.</p>
		</div>

		<div className="body">
			<textarea
				ref={textareaRef}
				value={reason}
				onChange={handleTextareaInput}
				placeholder="Enter a reason for override"
				rows={1}
				required
				aria-invalid={error ? "true" : "false"}
				aria-describedby={error ? "skip-password-reason-error" : undefined}
				className={`${styles.textarea} textarea`}
			/>
			{error && (
				<div id="skip-password-reason-error" className="common-error-message" role="alert">
					{error}
				</div>
			)}
		</div>

		<div className="footer">
			<BorderedButton 
			text="Enter User Password" 
			onClick={handleEnterUserPassword}
			/>
			<PrimaryButton
				text="Submit"
				onClick={handleSubmit}
			/>
		</div>
	</div>
	);
};

export default SkipPasswordForMembership;
